import { createSlice } from "@reduxjs/toolkit";

import { authApi } from "@shared/api/rtkQuery";

const initialState = {
  accessToken: null,
  refreshToken: null,
  expiresAt: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Dispatched by AuthCallbackPage after redirect — triggers authListenerMiddleware → fetchUser
    logIn: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken ?? null;
      state.expiresAt = action.payload.expiresAt ?? null;
    },
    // Dispatched by baseQueryWithReauth after silent refresh — does NOT trigger authListenerMiddleware
    updateTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.expiresAt = action.payload.expiresAt;
    },
    logOutLocal: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.logOut.matchFulfilled, (state) => {
      Object.assign(state, initialState);
    });
  },
});

export const { logIn, updateTokens, logOutLocal } = authSlice.actions;
export const authReducer = authSlice.reducer;
